import { Link } from 'react-router-dom';

const categories = [
  {
    key: 'kr',
    label: '韩漫',
    icon: 'ri-heart-pulse-fill',
    desc: '韩国漫画精选，剧情精彩画风精美',
    color: 'accent',
  },
  {
    key: 'jp',
    label: '日漫',
    icon: 'ri-rocket-fill',
    desc: '经典日本漫画，热血冒险与搞笑日常',
    color: 'primary',
  },
  {
    key: 'cn',
    label: '国漫',
    icon: 'ri-vip-crown-fill',
    desc: '国产漫画崛起，国风奇幻精彩不断',
    color: 'secondary',
  },
];

export default function CategoryEntry() {
  return (
    <section className="max-w-[1440px] mx-auto px-4 md:px-6 py-12" aria-labelledby="category-title">
      <div className="flex items-center justify-between mb-8">
        <h2 id="category-title" className="font-heading text-2xl font-bold text-foreground-900">
          漫画分类
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group relative overflow-hidden rounded-lg p-6 min-h-[180px] flex flex-col justify-between cursor-pointer transition-transform hover:scale-[1.02]"
            style={{
              backgroundColor:
                cat.color === 'accent'
                  ? 'oklch(var(--accent-100) / 0.3)'
                  : cat.color === 'primary'
                    ? 'oklch(var(--primary-100) / 0.3)'
                    : 'oklch(var(--secondary-100) / 0.3)',
            }}
          >
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <i className={`${cat.icon} text-xl`}
                    style={{
                      color:
                        cat.color === 'accent'
                          ? 'oklch(var(--accent-500))'
                          : cat.color === 'primary'
                            ? 'oklch(var(--primary-500))'
                            : 'oklch(var(--secondary-500))',
                    }}
                  ></i>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">
                    {cat.label}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600">{cat.desc}</p>
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/80 group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-right-line text-foreground-600"></i>
              </div>
            </div>

            <div className="mt-4 flex flex-wrap gap-1.5">
              {['热血', '恋爱', '奇幻', '搞笑'].map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-full text-xs bg-background-50/60 text-foreground-700"
                >
                  {tag}
                </span>
              ))}
              <span className="px-2.5 py-1 rounded-full text-xs bg-background-50/60 text-foreground-500">
                更多...
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}